import Seo, { baseOrgSchema, websiteSchema } from '@/components/feature/Seo';
import Hero from '@/pages/home/components/Hero';
import CategorySection from '@/pages/home/components/CategorySection';
import PopularSection from '@/pages/home/components/PopularSection';
import StatusSection from '@/pages/home/components/StatusSection';
import TagsSection from '@/pages/home/components/TagsSection';
import FaqSection from '@/pages/home/components/FaqSection';
import { siteConfig } from '@/config/site';
import { mangaCategories, mangaList, allTags } from '@/mocks/manga';

function Home() {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '漫画网如何按题材分类找漫画？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '进入「题材分类」页面后，可以看到热血冒险、玄幻修仙、恋爱甜宠、悬疑推理、搞笑日常、科幻末世等六大分类，点击即可浏览对应题材的漫画。',
        },
      },
      {
        '@type': 'Question',
        name: '如何区分完结漫画和连载中漫画？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '每部漫画封面会标注「完结」或「连载中」标签，也可在分类页通过状态筛选一键查看完结或连载中的全部漫画。',
        },
      },
      {
        '@type': 'Question',
        name: '可以通过标签找漫画吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '可以，在首页热门标签找书板块和分类页中点击热血、恋爱、科幻等标签，即可筛选出包含该标签的所有漫画。',
        },
      },
    ],
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: `${siteConfig.name} - 在线漫画阅读平台`,
    url: `${siteConfig.url}/`,
    description: siteConfig.description,
    inLanguage: 'zh-CN',
    isPartOf: { '@type': 'WebSite', name: siteConfig.name, url: siteConfig.url },
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: mangaList.slice(0, 8).map((m, i) => ({
        '@type': 'ListItem',
        position: i + 1,
        name: m.title,
        url: `${siteConfig.url}/article/${m.slug}`,
      })),
    },
  };

  return (
    <>
      <Seo
        title="在线漫画阅读平台"
        path="/"
        description={siteConfig.description}
        jsonLd={[baseOrgSchema, websiteSchema, webpageSchema, faqSchema]}
      />
      <Hero />
      <CategorySection />
      <PopularSection />
      <StatusSection />
      <TagsSection />
      <FaqSection />
      <div className="sr-only" aria-hidden="true">
        {mangaCategories.map((c) => c.name).join('，')}，{allTags.join('，')}
      </div>
    </>
  );
}

export default Home;